import { BackendApiClient } from './backend-client';
import type { AccountHolderResponse, AccountHolder } from '../model/types';

const backendClient = new BackendApiClient();

export async function getAccountHolders(sessionId: string, status?: 'active' | 'inactive' | 'pending'): Promise<AccountHolderResponse> {
  try {
    const endpoint = status ? `/account-holder?status=${status}` : '/account-holder';
    const response = await backendClient.get(endpoint, sessionId);
    if (response.success && response.data) {
      return response.data as AccountHolderResponse;
    } else {
      throw new Error(response.error || 'Failed to fetch organizations');
    }
  } catch (error) {
    throw new Error(`Failed to fetch organizations: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}

export async function getAccountHolderById(sessionId: string, holderId: string): Promise<AccountHolder> {
  try {
    // Create scope context for the holder
    const scopeContext = {
      scopeId: holderId,
      scopeType: 'holder' as const
    };
    
    const response = await backendClient.get('/account-holder', sessionId, scopeContext);
    if (response.success && response.data) {
      return response.data as AccountHolder;
    } else {
      throw new Error(response.error || 'Failed to fetch organization');
    }
  } catch (error) {
    throw new Error(`Failed to fetch organization: ${error instanceof Error ? error.message : 'Unknown error'}`);
  }
}

export function getActiveAccountHolders(accountHolders: AccountHolder[]): AccountHolder[] {
  // This function is now mainly for backward compatibility
  // Since we filter at the API level, this should return the same array
  return accountHolders.filter(holder => holder.status === 'active');
}

export function selectDefaultAccountHolder(accountHolders: AccountHolder[]): AccountHolder | null {
  // Since we now filter at the API level, all holders should be active
  if (accountHolders.length === 1) {
    return accountHolders[0];
  }
  
  return null; // User needs to select manually
}
